<Text text={textValue} color={textColor} size={textSize} fontFamily={textFontFamily} style={textStyle} />

<script>
import { computed } from "canvasengine";
import { resolveDynamicValue } from "./parse-value";

const { object, value, style } = defineProps();
const sprite = object();

const read = (prop, fallback) => prop ? prop() : fallback;

const parseNumericStyleValue = (value, object) => {
    value = resolveDynamicValue(value, sprite);
    if (value === undefined || value === null) return undefined;
    if (typeof value === 'number') return value;

    const num = parseFloat(value);
    return isNaN(num) ? undefined : num;
};

const getTextStyle = (style) => {
    if (!style) return {};
    const textStyle = {};

    if (style.fontStyle !== undefined) {
        textStyle.fontStyle = resolveDynamicValue(style.fontStyle, sprite);
    }

    if (style.fontWeight !== undefined) {
        textStyle.fontWeight = resolveDynamicValue(style.fontWeight, sprite);
    }

    if (style.stroke !== undefined) {
        textStyle.stroke = resolveDynamicValue(style.stroke, sprite);
    }

    if (style.opacity !== undefined) {
        const opacityValue = parseNumericStyleValue(style.opacity, object);
        if (opacityValue !== undefined) {
            textStyle.opacity = opacityValue;
        }
    }

    if (style.wordWrap !== undefined) {
        textStyle.wordWrap = style.wordWrap;
    }

    if (style.align !== undefined) {
        textStyle.align = resolveDynamicValue(style.align, sprite);
    }

    return textStyle;
};

const textValue = computed(() => String(resolveDynamicValue(read(value, ''), sprite) ?? ''));
const textColor = computed(() => {
    const currentStyle = read(style, {});
    return currentStyle.fill !== undefined ? resolveDynamicValue(currentStyle.fill, sprite) : undefined;
});
const textSize = computed(() => {
    const currentStyle = read(style, {});
    return currentStyle.fontSize !== undefined ? parseNumericStyleValue(currentStyle.fontSize, object) : undefined;
});
const textFontFamily = computed(() => {
    const currentStyle = read(style, {});
    return currentStyle.fontFamily !== undefined ? resolveDynamicValue(currentStyle.fontFamily, sprite) : undefined;
});
const textStyle = computed(() => getTextStyle(read(style, {})));
</script>
